import { useApi } from '@hooks/useApi';
import { ApiError } from '@root/globalTypes';
import { MerchantUser } from '@root/globalTypes';
import { useMutation } from '@tanstack/react-query';

export type UserResponse = MerchantUser | ApiError;

type RequestResetPasswordParams = {
  id: string;
  callback: () => void;
};

export function useUserResetPassword({ id, callback }: RequestResetPasswordParams) {
  const { query } = useApi();
  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<UserResponse> => {
      return query({
        path: `v1/merchant/users/${id}/password`,
        opt: {
          method: 'POST',
        },
      });
    },
    onSettled: (data) => {
      if (!data) return;
      callback();
    },
  });

  return {
    mutate,
    isPending,
  };
}
